module.exports = __webpack_public_path__ + "static/media/hero22.e1d9f08e.jpg";